import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { setSelectedDisclaimer, openModal } from 'src/redux/configurator/actions';

import usePrice from 'src/hooks/usePrice';

import Label from 'components/_utility/Label';

import InfoCircle from 'src/assets/icons/info-circle.svg';
import { TaxWrap, TaxTitle, TaxTotal, InfoCircleWrap } from './LuxuryTaxTotal.styled';

const LuxuryTaxTotal = ({ price, type, label }) => {
  const dispatch = useDispatch();
  const formatPrice = usePrice();
  const infoButtonRef = useRef();
  const luxuryTaxTotalRef = useRef();

  return (
    <TaxWrap>
      <TaxTitle>
        <Label name={label} />
      </TaxTitle>
      <TaxTotal ref={luxuryTaxTotalRef}>
        <InfoCircleWrap
          onClick={() => {
            dispatch(setSelectedDisclaimer(type));
            dispatch(openModal('disclaimer'));
          }}
          ref={infoButtonRef}
        >
          <InfoCircle />
        </InfoCircleWrap>
        {formatPrice(price)}
      </TaxTotal>
    </TaxWrap>
  );
};

export default LuxuryTaxTotal;
